module.exports = __webpack_public_path__ + "static/media/signout.0ea47ca8.svg";